import React from 'react';
import { Container } from 'flux/utils';

import { SPLASH, INTRO, SETTINGS, APP, READMORE, DRINKS, CALCULATOR } from '../stores/route';
import routeStore from '../stores/route';

import AppContainer from './app-container';
import Splash from './splash';
import Intro from './intro';
import SettingsContainer from './settings-container';
import ReadMore from './read-more';
import DrinksList from './drinks-list';
import Calculator from './calculator';


const routeMap = new Map();
routeMap.set(SPLASH, Splash);
routeMap.set(APP, AppContainer);
routeMap.set(INTRO, Intro);
routeMap.set(SETTINGS, SettingsContainer);
routeMap.set(READMORE, ReadMore);
routeMap.set(DRINKS, DrinksList);
routeMap.set(CALCULATOR, Calculator);
routeMap.set(undefined, Intro);

class Router extends React.Component {

  static getStores() {
    return [routeStore];
  }

  static calculateState() {
    const { route } = routeStore.getState();
    return {
      route,
    };
  }

  render() {
    const View = routeMap.get(this.state.route);
    return (
      <div id="router">
        <View />
      </div>
    );
  };
}

export default Container.create(Router);



// WEBPACK FOOTER //
// ./src/components/router.js